import {any} from "prop-types";
import {SUCCESS_API_CALL} from "../constants/action-types";

const initialState ={
    data:any
};

const acceptedReducer = (state = initialState,action:any)=>{
    switch (action.type) {
        case SUCCESS_API_CALL:{
            return {
                ...state,
                data: action.data,
                loading:false
            };
        }
        default:
            return state;
    }
};

export default acceptedReducer;
